import "./Pagination.css";

// Windowed page numbers: 1 … (cur-1) cur (cur+1) … last. Small round buttons, matching
// the AllChats pagination (light theme here). Shared by the launch pages' file tables.
const getPageWindow = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const wanted = [1, total, current, current - 1, current + 1].filter((p) => p >= 1 && p <= total);
  const uniqueSorted = [...new Set(wanted)].sort((a, b) => a - b);
  const out = [];
  let prev = 0;
  for (const p of uniqueSorted) {
    if (p - prev > 1) out.push("...");
    out.push(p);
    prev = p;
  }
  return out;
};

export default function Pagination({ page, totalPages, onChange }) {
  const total = Number(totalPages) || 0;
  if (total <= 1) return null;
  const cur = Math.min(Math.max(1, Number(page) || 1), total);
  return (
    <div className="cg-pagination">
      <button
        className="cg-page-btn cg-page-arrow"
        disabled={cur === 1}
        onClick={() => onChange(Math.max(1, cur - 1))}
        aria-label="Previous page"
      >
        ‹
      </button>
      {getPageWindow(cur, total).map((p, i) =>
        p === "..." ? (
          <span key={`gap-${i}`} className="cg-page-ellipsis">…</span>
        ) : (
          <button
            key={p}
            className={`cg-page-btn ${p === cur ? "active" : ""}`}
            onClick={() => onChange(p)}
          >
            {p}
          </button>
        )
      )}
      <button
        className="cg-page-btn cg-page-arrow"
        disabled={cur === total}
        onClick={() => onChange(Math.min(total, cur + 1))}
        aria-label="Next page"
      >
        ›
      </button>
    </div>
  );
}
